import palette from "../palette";

export default {
    textColorInherit: {
        "&$selected": {
            color: palette.text.primary, 
            fontWeight: 600,
        },
        color: "#000000",
        fontFamily: 'Public Sans, sans-serif',
        fontWeight: 500,
        fontSize: '14px'
    },
    wrapper: {
        flexDirection: "none",
        justifyContent: 'start',
    },
    root: {
        width:'fit-content'
    }
}